import { gql } from '@apollo/client'

import { MutationService, getMutationService } from '../../../../helpers/GraphqlHelpers'
import { UserFragment } from '../../../fragments'
import { SocialLoginMutation } from '../../../generated/graphql'

export const socialLogin: MutationService = getMutationService({
  mutation: gql`
    mutation socialLogin($institution: ID!, $code: String!) {
      socialLogin(institution: $institution, code: $code) {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  transformer: (response: SocialLoginMutation) => {
    return response.socialLogin
  },
})
